module.exports = __webpack_public_path__ + "img/check-arrow.a5cc3d99.svg";